import React from 'react';
import * as Context from 'fw/system/Context'

const FACTOR = 1000 * 60;
const CLEAR_TOKEN_DELAY = 3000;

class TimeoutControl extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			intervalId: setTimeout(this.doSomething, props.minutes * FACTOR)
		};

		this.addListeners();
	}

	componentWillUnmount = () => {
		this.removeListeners();

		if (this.state.intervalId !== undefined)
			clearTimeout(this.state.intervalId);
	}	

	resetTimer = () => {
		if (this.state.intervalId !== undefined)
			clearTimeout(this.state.intervalId);

		this.setState({
			intervalId: setTimeout(this.doSomething, this.props.minutes * FACTOR)
		});
	}

	doSomething = () => {
		// Do app action
		this.props.onTimeout();

		// Clear the token with a given delay, to aovid re-renders based on expired tokens
		setTimeout(function() {
			// Clear token
			Context.remove("token");
		}, CLEAR_TOKEN_DELAY);
	}

	addListeners = () => {
		window.addEventListener('keydown', this.resetTimer);
		window.addEventListener('click', this.resetTimer);
	}

	removeListeners = () => {
		window.removeEventListener('keydown', this.resetTimer);
		window.removeEventListener('click', this.resetTimer);
	}

	render() {
		return null;
	}
}

export default TimeoutControl;


// WEBPACK FOOTER //
// ./src/fw/components/timeoutControl/TimeoutControl.js